import { inject, injectable } from 'inversify';
import {
  ComplaintsRepositoryInterface,
  PostOrderComplaintPayload,
} from 'src/features/complaints/domain/ComplaintsRepositoryInterface';
import ComplaintsService from 'src/features/complaints/data/service/ComplaintsService';

@injectable()
class ComplaintsRepository implements ComplaintsRepositoryInterface {
  @inject(ComplaintsService)
  private complaintsService!: ComplaintsService;

  async postOrderComplaint(params: PostOrderComplaintPayload) {
    const response = await this.complaintsService.postOrderComplaint(params);

    return response.data;
  }
}

export default ComplaintsRepository;
